import { CloseOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { memo, useMemo, useState } from "react";

import { normalizeTimeValue } from "../../../utils/functions";

const TimePickerFilter = ({ currentValue, fieldName, title, updateFilter }) => {
const [localValue, setLocalValue] = useState(currentValue);

const normalizedValue = useMemo(() => {
  if (localValue === null || localValue === undefined || localValue === "") {
    return null;
  }
  return normalizeTimeValue(localValue);
}, [localValue]);


const handleOnTimeChange = (newValue) => {
  if (!newValue) {
    updateFilter(fieldName, undefined);
    setLocalValue(null);
    return;
  }
  setLocalValue(newValue);
  updateFilter(fieldName, newValue);
  
};

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        label={title}
        value={normalizedValue}
        onChange={handleOnTimeChange}
        views={["hours", "minutes"]}
        format="HH:mm"
        className="w-full my-1 mr-1 text-center"
        slotProps={{
          textField: { variant: "outlined" },
        }}
      />

      {currentValue && (
        <Button
          variant="text"
          onClick={() => handleOnTimeChange(null)}
          className="p-0 text-sm text-red-600 w-fit hover:bg-transparent hover:text-red-400"
        >
          <CloseOutlined />
        </Button>
      )}
    </LocalizationProvider>
  );
};

export default memo(TimePickerFilter);
